<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Chapter1#C1">1. The Marriages of Two Families</a></p>
<p class="toc"><span href="#/Chapter2#C2" title="Link target outside of Sample">2. Arvilla</span></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. Scandal in Jordanville</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. <i>Wallis v. Wallis</i></span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. Divorced in Detroit</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. May 4, 1901</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">7. The New Sheriff</span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">8. The Press and John C. Wallis</span></p>
<p class="toc"><span href="#/Chapter9#C9" title="Link target outside of Sample">9. The Coroner’s Inquest</span></p>
<p class="toc"><span href="#/Chapter10#C10" title="Link target outside of Sample">10. A Forced Marriage?</span></p>
<p class="toc"><span href="#/Chapter11#C11" title="Link target outside of Sample">11. “My Own Dear Boy”</span></p>
<p class="toc"><span href="#/Chapter12#C12" title="Link target outside of Sample">12. The Wallis Men Tell Their Stories</span></p>
<p class="toc"><span href="#/Chapter13#C13" title="Link target outside of Sample">13. The Mute Witnesses</span></p>
<p class="toc1"><span href="#/Afterword" title="Link target outside of Sample">Afterword</span></p>
<p class="toc"><span href="#/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?3a1fd48e